
  <div class="w-100 fix-height d-flex flex-column justify-content-center align-items-center pt-4">
  <h1 class="pb-4">{{ "base.not_allowed" | translate}}</h1>
  <i class="fa-5x text-danger fas fa-ban"></i>
</div>